var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"showcase"},[_c('div',{staticClass:"imgs-row"},_vm._l((_vm.showcase),function(img){return _c('div',{key:img.url},[_c('div',[_c('img',{staticClass:"product-image",attrs:{"src":img.url,"alt":_vm.title}})])])}),0)])}
var staticRenderFns = []

export { render, staticRenderFns }